import React, { useState, useEffect } from "react";
import Joi from "joi-browser";
import axios from "axios";
import Input from "../../common/input";
import { apiUsers } from "../../config.json";
import { saveUser } from "../../services/userService";
import "./SignUp.css";

function SignUp(props) {
  const [account, setAccount] = useState({ username: "", password: "" });
  const [allerrors, setError] = useState({});
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    const getAllUsers = async () => {
      try {
        const result = await axios.get(apiUsers, {
          cancelToken: source.token,
        });
        setUsers(result.data);
      } catch (error) {
        if (axios.isCancel(error)) {
        } else {
          throw error;
        }
      }
    };

    getAllUsers();

    return () => {
      source.cancel();
    };
  });

  const scheme = {
    username: Joi.string().required().email().label("Username"),
    password: Joi.string().required().min(5).label("Password"),
  };

  const validate = () => {
    const { error } = Joi.validate(account, scheme, { abortEarly: false });
    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAccount({ ...account, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validate();
    setError(errors || {});
    if (errors) return;

    await saveUser(account);
    props.history.push("/");
  };

  return (
    <div>
      <div className="sign-up">
        <h1>Sign Up</h1>
        <form onSubmit={handleSubmit}>
          <div className="from-area">
            <div className="username-area">
              <Input
                type="text"
                name="username"
                placeholder="Enter Email"
                value={account.username}
                error={allerrors.username}
                onChange={handleChange}
              />
            </div>
            <div className="password-area">
              <Input
                type="password"
                name="password"
                placeholder="Enter Password"
                error={allerrors.password}
                value={account.password}
                onChange={handleChange}
              />
            </div>
            <button className="btn--primary">SignUp</button>
          </div>
        </form>
      </div>
      <ul>
        {users.map((user) => (
          <li key={user._id}>{user.username}</li>
        ))}
      </ul>
    </div>
  );
}

export default SignUp;
